import React from 'react';
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils';
import GenericPullConfigListing from '../GenericPullConfigListing';
import TwistLockCredentialsForm from './TwistLockCredentialsForm';
import TwistLockMappingFormV2 from './TwistLockMappingFormV2';
import _ from 'lodash';
import { Typography } from 'antd';
import ContentOverlay from 'components/ContentOverlay';


const {Link} = Typography;
const NA = CellRenderers.VALUE_OR_NA();

export const renderLinks = (imageName, record, assetType, toolName, ids) => {
    if(!imageName){
        return NA;
    }
    const idsArray = _.split(ids, ",");
    const imageNames = _.split(imageName, ",");
    const content = imageNames.map((name, i) => {
        if(name === "All"){
            return <p>{name}</p>
        }
        return (
            <p>
                <Link
                    target="_blank"
                    href={`/user/tools/generic/project/${toolName}/redirect?login_id=${
                        record.login_id
                    }&assetType=${assetType}&name=${ids ? idsArray[i] : name}`}
                >
                    {name}
                </Link>
            </p>
        );
    });
    return <ContentOverlay content={content} minHeight={40} />;
}

export default function TwistLockConfigListing(props) {

    const columns = [
        {
            title: "Image",
            dataIndex: "imageName",
            width: 240,
            render: (imageName, record) => renderLinks(imageName, record, "images/deployed", props.name,)
        }, {
            title: "Host",
            dataIndex: "hostName",
            width: 240,
            render: (hostName, record) => {
                return hostName === "ALL-HOSTS"
                    ? "All"
                    : renderLinks(
                        hostName,
                        record,
                        "hosts/deployed",
                        props.name,
                    );
            },
            filterLabelFormatter: (val) => val === "ALL-HOSTS" ? "All" : val
        },{
            title: "Registry",
            dataIndex: "registryName",
            width: 240,
            render: (registryName, record) => renderLinks(registryName, record, "images/registries", props.name,)
        },{
            title: "CI",
            dataIndex: "ciImageName",
            width: 240,
            render: (ciImageName, record) => renderLinks(ciImageName, record, "images/ci", props.name,)
        },{
            title: "Application Security",
            dataIndex: "codeRepoName",
            width: 240,
            render: (codeRepoName, record) => renderLinks(codeRepoName, record, "code-security", props.name,)
        }
        // ,{
        //     title: "Code Repository",
        //     dataIndex: "codeRepositoryName",
        //     width: 240,
        //     render: (codeRepositoryName, record) => {
        //         // the sequence of name and id are not retained, name contains the repo type as prefix and id has the actual name
        //         // hence sorting makes them in proper sequence
        //         const sortedName = codeRepositoryName !== '' ? _.split(codeRepositoryName, ",").sort() : false;
        //         const sortedId = _.split(record.codeRepositoryId, ",").sort();
        //         return renderLinks(sortedName, record, "coderepos/repositories", props.name, sortedId)
        //     }
        // }
        ,{
            title: "Cluster",
            dataIndex: "clusterName",
            width: 240,
            render: columnRenderArrayData
        },{
            title: "Host Cluster",
            dataIndex: "hostClusterName",
            width: 240,
            render: columnRenderArrayData
        }
    ]

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={TwistLockMappingFormV2}
            CredentialsForm={TwistLockCredentialsForm}
            triggerModifyParam={triggerModifyParam}
            extraColumns={columns}
        />
    )
}

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}